import { PageSlice, ProductCode } from '@contracts';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import styled from 'styled-components';
import Colors from './Colors';
import LinkButton from './LinkButton';

interface Props {
  slice: PageSlice;
}

const BREAKPOINT = '1200px';

const ProductUpsellRow: React.FC<Props> = ({ slice }) => {
  const { t } = useTranslation();

  const productsData = [
    {
      code: ProductCode.Proviotics,
      title: t('product-upsell.proviotics.title'),
      text: t('product-upsell.proviotics.text'),
      buttonText: t('product-upsell.proviotics.button'),
      buttonLink: '/products/proviotics',
      background: 'linear-gradient(180deg, #FAEEEB 0%, #DBE8F1 100%)',
      image: 'https://images.prismic.io/ecommerce-website/1913ae08-1b1c-46e5-8253-eadc9c2bbef9_proviotics_module_img.png?auto=compress,format'
    }
  ];

  const productData = productsData.find((product) => product.code === slice?.primary?.product);

  if (!productData) return null;

  return (
    <Container $background={productData.background}>
      <Text>
        <TextStyle4>{productData.title}</TextStyle4>
        <h4>{productData.text}</h4>
        <LinkButton to={productData.buttonLink}>{productData.buttonText}</LinkButton>
      </Text>
      <ImageWrap>
        <img src={productData.image} alt={productData.title} />
      </ImageWrap>
    </Container>
  );
};

export default ProductUpsellRow;

const Container = styled.div<{ $background: string }>`
  display: flex;
  height: 400px;
  padding: 0 120px;
  align-items: center;
  gap: 25px;
  align-self: stretch;
  background: ${(props) => props.$background};

  @media (max-width: ${BREAKPOINT}) {
    flex-direction: column;
    height: auto;
    padding: 0 20px;
  }
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin: 60px 0;

  @media (max-width: ${BREAKPOINT}) {
    margin: 30px 0;
  }

  & h4 {
    font-family: 'Domaine';
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: -0.4px;
    color: ${Colors.navyBlue};
    text-align: center;
    text-shadow: 0px 4px 30px rgba(0, 0, 0, 0.05);
    margin-bottom: 14px;

    @media (max-width: ${BREAKPOINT}) {
      font-size: 24px;
    }
  }
`;

const TextStyle4 = styled.p`
  /* TODO: Move to global design system */
  font-family: 'BrownStd';
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${Colors.navyBlue};
`;

const ImageWrap = styled.div`
  display: flex;
  width: 560px;
  flex-shrink: 0;
  max-width: 100%;

  & img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`;
